export default __webpack_public_path__ + "static/i-fps-blue-4a5434ea5efd6a7c72ac60ed73177a06.svg";